export { SkyLabelComponent } from './label.component';
export { SkyLabelModule } from './label.module';
